import compose from 'recompose/compose';
import { withAnalytics } from '@carvana/analytics';
import Error from './error';

export default compose(
  withAnalytics({
    componentName: 'Error',
    enableComponentTracking: true
  })
)(Error);
